$(document).ready(function () {
  $(document).ajaxStop(function () {
    var input = document.getElementById("news-application-form-file-upload");
    var preview = document.querySelector(".upload-notice-jobs");
    var fileTypes = ["application/pdf"];

    /*
    if ($("#news-application-form").length) {
      $("[data-jobOffer]").each(function () {
        if($(this).data('joboffer') != '') {
          $(this).find('#news-application-form-jobOffer').val($(this).data('joboffer')).attr('readonly', true);
        }
      });
    }
    */

    if ($("#news-application-form").length || $("#news-application-form-bwo").length || $("#news-application-form-lebenspfade").length) {
      $("[data-jobOffer]").each(function () {
        if ($(this).data('joboffer') != '') {
          var jobOfferValue = $(this).data('joboffer');
          $(this).find('#news-application-form-jobOffer, #news-application-form-bwo-jobOffer, #news-application-form-lebenspfade-jobOffer')
                 .val(jobOfferValue)
                 .attr('readonly', true);
        }
      });
    }
    

    if($(input).length) {
      input.style.opacity = 0;
      input.addEventListener("change", updateDisplay);
    }

    function updateDisplay() {
      while (preview.firstChild) {
        preview.removeChild(preview.firstChild);
      }

      var curFiles = input.files;
      if (curFiles.length === 0) {
        preview.innerHTML = "Bewerbungsunterlagen als PDF; max. 15MB";
      } else {
        var file = curFiles[0];
        var textContent = "";

        if (validFileType(file)) {
          if (validFileSize(file.size)) {
            textContent =
            "Dateiname: " + file.name + ", Dateigröße: " + returnFileSize(file.size) + ".";
            preview.innerHTML = textContent;
          } else {
            textContent =
            "Die Datei " + file.name + " ist mit " + returnFileSize(file.size) + " zu groß. Die maximal zulässige Größe beträgt 15MB.";
            preview.innerHTML = textContent;
          }
        } else {
          textContent =
            "Datei " + file.name + ": Dateityp ist nicht erlaubt. Bitte laden Sie eine gültige PDF-Datei hoch.";
            preview.innerHTML = textContent;
        }
      }
    }

    function validFileType(file) {
      return fileTypes.includes(file.type);
    }

    function validFileSize(size) {
      if(size <= 15728640) return true;
      return false;
    }

    function returnFileSize(number) {
      if (number < 1024) {
        return number + " Bytes";
      } else if (number >= 1024 && number < 1048576) {
        return (number / 1024).toFixed(1) + " kB";
      } else if (number >= 1048576) {
        return (number / 1048576).toFixed(1) + " MB";
      }
    }
  });
});
